import { render, staticRenderFns } from "./VtDateFilter.vue?vue&type=template&id=65c9b7f1"
import script from "./VtDateFilter.vue?vue&type=script&lang=js"
export * from "./VtDateFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports